import { collectEvent, UserAction, userActionTypeEnum, } from '@thoughtspot/metrics';
const commonProps = () => ({
    timestamp: Date.now(),
});
export const trackOrgTabViewed = (props) => {
    collectEvent(new UserAction(userActionTypeEnum.ADMIN_ORG_TAB_VIEWED), {
        ...commonProps(),
        ...props,
    });
};
export const trackOrgListSearched = (props) => {
    collectEvent(new UserAction(userActionTypeEnum.ADMIN_ORG_LIST_SEARCHED), {
        ...commonProps(),
        ...props,
    });
};
export const trackOrgListFiltered = (props) => {
    collectEvent(new UserAction(userActionTypeEnum.ADMIN_ORG_LIST_FILTERED), {
        ...commonProps(),
        ...props,
    });
};
export const trackOrgListSorted = (props) => {
    collectEvent(new UserAction(userActionTypeEnum.ADMIN_ORG_LIST_SORTED), {
        ...commonProps(),
        ...props,
    });
};
export const trackOrgListPaginated = (props) => {
    collectEvent(new UserAction(userActionTypeEnum.ADMIN_ORG_LIST_PAGINATED), {
        ...commonProps(),
        ...props,
    });
};
export const trackOrgCreateClicked = (props) => {
    collectEvent(new UserAction(userActionTypeEnum.ADMIN_ORG_CREATE_CLICKED), {
        ...commonProps(),
        ...props,
    });
};
export const trackOrgCreateDialogViewed = (props) => {
    collectEvent(new UserAction(userActionTypeEnum.ADMIN_ORG_CREATE_DIALOG_VIEWED), { ...commonProps(), ...props });
};
export const trackOrgCreateStepCompleted = (props) => {
    collectEvent(new UserAction(userActionTypeEnum.ADMIN_ORG_CREATE_STEP_COMPLETED), { ...commonProps(), ...props });
};
export const trackOrgCreateSubmitted = (props) => {
    collectEvent(new UserAction(userActionTypeEnum.ADMIN_ORG_CREATE_SUBMITTED), { ...commonProps(), ...props });
};
export const trackOrgCreateSucceeded = (props) => {
    collectEvent(new UserAction(userActionTypeEnum.ADMIN_ORG_CREATE_SUCCEEDED), { ...commonProps(), ...props });
};
export const trackOrgCreateFailed = (props) => {
    collectEvent(new UserAction(userActionTypeEnum.ADMIN_ORG_CREATE_FAILED), {
        ...commonProps(),
        ...props,
    });
};
export const trackOrgCreateCancelled = (props) => {
    collectEvent(new UserAction(userActionTypeEnum.ADMIN_ORG_CREATE_CANCELLED), { ...commonProps(), ...props });
};
export const trackOrgDetailsViewed = (props) => {
    collectEvent(new UserAction(userActionTypeEnum.ADMIN_ORG_DETAILS_VIEWED), {
        ...commonProps(),
        ...props,
    });
};
export const trackOrgEditClicked = (props) => {
    collectEvent(new UserAction(userActionTypeEnum.ADMIN_ORG_EDIT_CLICKED), {
        ...commonProps(),
        ...props,
    });
};
export const trackOrgEditSaved = (props) => {
    collectEvent(new UserAction(userActionTypeEnum.ADMIN_ORG_EDIT_SAVED), {
        ...commonProps(),
        ...props,
    });
};
export const trackOrgEditFailed = (props) => {
    collectEvent(new UserAction(userActionTypeEnum.ADMIN_ORG_EDIT_FAILED), {
        ...commonProps(),
        ...props,
    });
};
export const trackOrgStatusChanged = (props) => {
    collectEvent(new UserAction(userActionTypeEnum.ADMIN_ORG_STATUS_CHANGED), {
        ...commonProps(),
        ...props,
    });
};
export const trackOrgMemberAdded = (props) => {
    collectEvent(new UserAction(userActionTypeEnum.ADMIN_ORG_MEMBER_ADDED), {
        ...commonProps(),
        ...props,
    });
};
export const trackOrgMemberRemoved = (props) => {
    collectEvent(new UserAction(userActionTypeEnum.ADMIN_ORG_MEMBER_REMOVED), {
        ...commonProps(),
        ...props,
    });
};
export const trackOrgSwitched = (props) => {
    collectEvent(new UserAction(userActionTypeEnum.ADMIN_ORG_SWITCHED), {
        ...commonProps(),
        ...props,
    });
};
export const trackOrgDeleteClicked = (props) => {
    collectEvent(new UserAction(userActionTypeEnum.ADMIN_ORG_DELETE_CLICKED), {
        ...commonProps(),
        ...props,
    });
};
export const trackOrgDeleteConfirmed = (props) => {
    collectEvent(new UserAction(userActionTypeEnum.ADMIN_ORG_DELETE_CONFIRMED), { ...commonProps(), ...props });
};
export const trackOrgDeleteSucceeded = (props) => {
    collectEvent(new UserAction(userActionTypeEnum.ADMIN_ORG_DELETE_SUCCEEDED), { ...commonProps(), ...props });
};
export const trackOrgDeleteFailed = (props) => {
    collectEvent(new UserAction(userActionTypeEnum.ADMIN_ORG_DELETE_FAILED), {
        ...commonProps(),
        ...props,
    });
};
export const trackOrgDeleteCancelled = (props) => {
    collectEvent(new UserAction(userActionTypeEnum.ADMIN_ORG_DELETE_CANCELLED), { ...commonProps(), ...props });
};
//# sourceMappingURL=org-management-analytics.js.map